import moment from '../lib/moment';

export class Notification {
  /**
   *
   * @param {HTMLElement} options.container
   */
  constructor(options) {
    this.container = (options ? options.container : null) || document.querySelector('header') || document.body;

    this.badgeElement = document.querySelector('[data-notification] [data-name="badge"]');
  }

  initialize() {
    this.opended = false;

    this.container.ownerDocument.body.addEventListener('click', e => {

      /**
       * @type {HTMLElement}
       */
      let trigger = e.target;

      if (trigger.dataset.notification === undefined) {
        trigger = trigger.closest('[data-notification]');
      }

      if (trigger === null || trigger.dataset.notification === undefined) {
        if (this.opended) {
          this.closeListView();
        }

        return;
      }

      e.preventDefault();

      if (this.opended) {
        return;
      }

      this.openListView(trigger);
    });

    this.fetchNotifications()
      .then(payload => {
        this.notifications = payload.data;
        this.unreadCount = payload.unreadCount;
        this.renderBadge(this.unreadCount);
      });
  }

  fetchNotifications() {
    return fetch(
      '/api/1/front/notifications',
      {
        method: 'GET',
      }
    )
      .then(response => {
        return response.json();
      });
  }

  /**
   * @param {number} count
   */
  renderBadge(count) {
    this.badgeElement.style.visibility = count > 0 ? 'visible' : 'hidden';
    this.badgeElement.textContent = count.toLocaleString();
  }

  /**
   * @param {HTMLElement} trigger
   */
  openListView(trigger) {
    this.listView = this.buildListView();

    const triggerPosition = trigger.getBoundingClientRect();
    this.listView.style.top = triggerPosition.bottom + 'px';

    this.container.appendChild(this.listView);

    this.updateListView(this.notifications);

    this.opended = true;
  }

  closeListView() {
    this.listView.remove();

    this.opended = false;
  }

  buildListView() {
    const list = this.container.ownerDocument.createElement('div');
    list.className = 'notification-list';

    return list;
  }

  /**
   * @param {Array} notifications
   */
  updateListView(notifications) {
    this.listView.innerHTML = '';

    notifications.forEach(notification => {
      const item = this.container.ownerDocument.createElement('a');
      item.classList.add('notification-list-item');
      item.href = `/notifications/${encodeURIComponent(notification.id)}`;

      const content = this.container.ownerDocument.createElement('span');
      content.classList.add('notification-list-item__content');
      content.textContent = notification.content;
      item.appendChild(content);

      const datetime = this.container.ownerDocument.createElement('time');
      datetime.classList.add('notification-list-item__datetime');
      datetime.textContent = moment(new Date(notification.created_at)).format('Y年M月D日 HH:mm');
      item.appendChild(datetime);

      if (notification.read) {
        const read = this.container.ownerDocument.createElement('span');
        read.classList.add('notification-list-item__read-mark');
        item.appendChild(read);

        item.classList.add('notification-list-item--read')
      } else {
        item.classList.add('notification-list-item--unread')
      }

      this.listView.appendChild(item);
    });

    (() => {
      const more = this.container.ownerDocument.createElement('a');
      more.classList.add('notification-list-read-more');
      more.href = '/notifications';
      more.textContent = '全てのお知らせを読む';

      this.listView.appendChild(more);
    })();
  }
}
